import styled, { css } from 'styled-components';
import Notification from '@service-victoria/component-library/components/Notification';
import Clock from '@service-victoria/component-library/components/Icons/Clock';
import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import Text from '@service-victoria/component-library/components/Text';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div<{ isHideFormOptions?: boolean }>`
  ul {
    margin-top: 0;
    color: ${colors.blueGrey};
  }

  ${props =>
    props.isHideFormOptions &&
    css`
      & + div {
        button {
          display: none;
        }
      }
    `}
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50vh;
`;

export const HeadingWrapper = styled(Wrapper)`
  min-height: 100%;
  margin-bottom: 32px;
`;

export const CustomLink = styled(Link)`
  color: ${colors.brown};
`;

export const Spacer8 = styled.div`
  padding-bottom: 8px;
`;

export const Spacer16 = styled(Wrapper)`
  margin-bottom: 16px;
`;

export const Spacer24 = styled(Wrapper)`
  margin-bottom: 24px;
`;

export const Spacer32 = styled(Wrapper)`
  margin-bottom: 32px;
`;

export const Spacer48 = styled(Wrapper)`
  margin-bottom: 48px;
`;

interface SpacerProps {
  space: number;
}

export const Spacer = styled(Wrapper)<SpacerProps>`
  margin-bottom: ${props => `${props.space}px`};
`;

export const ContentWrapper = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const DoneWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TickWrapper = styled(CircleTick)`
  width: 45px;
  height: 45px;
  margin-right: 16px;
`;

export const ClockWrapper = styled(Clock)`
  width: 45px;
  height: 45px;
  margin-right: 16px;
`;

export const Error = styled.div`
  > div {
    margin-top: 0;
  }
`;

export const List = styled.ul`
  padding-left: 0px 40px 0 6px;
  margin-top: -12px;
`;

export const ListItem = styled.li<{ display?: string }>`
  padding: 6px 0;

  > div {
    display: ${props => (props.display ? props.display : 'inline-flex')};
    > a {
      margin-right: 0;
    }
  }
`;

export const TextBodyCentered = styled.p`
  text-align: center;
  color: #3c4a60;
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const RadioContainer = styled.div`
  label {
    height: auto;
  }
`;

export const CheckboxContainer = styled.div`
  margin: 16px 4px;
`;

export const TextArea4LinesWrapper = styled.span`
  textarea {
    height: 6.3em !important; // god I hate this...
  }
`;

export const InverseMarginMobile = styled.div`
  @media ${device.isMobile} {
    margin-left: -32px;
    margin-right: -32px;
  }
`;

export const NotificationInfo = styled(Notification.Info)`
  > div {
    white-space: pre-line;
  }
`;

export const ApplicationDetails = styled(Text.Body)`
  word-break: break-word;
`;
